const QUOTE_PAIRS = [
  ["«", "»"],
  ["\u201C", "\u201D"],
  ["\u201E", "\u201D"],
  ['"', '"'],
  ["‹", "›"],
];

export function stripOuterLiteraryQuotes(text) {
  let content = String(text ?? "").trim();
  if (!content) return "";

  let changed = true;
  while (changed) {
    changed = false;
    for (const [open, close] of QUOTE_PAIRS) {
      if (content.startsWith(open) && content.endsWith(close)) {
        content = content.slice(open.length, content.length - close.length).trim();
        changed = true;
      }
    }
  }

  return content;
}

export function formatLiteraryExcerpt(text) {
  const content = stripOuterLiteraryQuotes(text);
  if (!content) return "";
  return `\u201C${content}\u201D`;
}
